import Splide from '@splidejs/splide';
import setCssVar from "../utils/setCssVar";

export default class LandingTicker {
  constructor(elem) {
    this.elem = elem;
    this.splide = this.elem.querySelector(".js-splide");
    this.splideInstance = null;
    this.slides = this.elem.querySelectorAll(".js-splide-slide");
    this.pauseButtons = this.elem.querySelectorAll(".js-pause-button");
    this.ambientVideo = this.elem.querySelector(".js-ambient-video");

    this.flags = {
      isPaused: false,
      prefersReducedMotion: false,
    }

    this.splideConfig = {
      direction: 'ttb',
      autoWidth: true,
      height: 'var(--line-height, 24px)',
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,
      type: 'loop',
      speed: 300,
      easing: 'ease-in-out',
      drag: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    }
  }

  checkReducedMotionPreference() {
    // Check if user prefers reduced motion
    this.flags.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // If user prefers reduced motion, pause the ticker
    if (this.flags.prefersReducedMotion) {
      this.flags.isPaused = true;
      this.updatePauseButtonStates();
    }
  }

  updatePauseButtonStates() {
    this.pauseButtons.forEach(button => {
      button.setAttribute("data-paused", this.flags.isPaused.toString());
      button.setAttribute("aria-label", this.flags.isPaused ? "Play Video" : "Pause Video");
    });
  }

  setupSplide() {
    this.splideInstance = new Splide(this.splide, this.splideConfig);
    this.splideInstance.mount();
    
    // If user prefers reduced motion, pause the autoplay
    if (this.flags.prefersReducedMotion) {
      this.splideInstance.Components.Autoplay.pause();
      if (this.ambientVideo) {
        this.ambientVideo.pause();
      }
    }
  }

  handlePauseButton() {
    this.flags.isPaused = !this.flags.isPaused;

    switch (this.flags.isPaused) {
      case true:
        this.updatePauseButtonStates();
        this.splideInstance.Components.Autoplay.pause();
        if (this.ambientVideo) {
          this.ambientVideo.pause();
        }
        break;
      case false:
        this.updatePauseButtonStates();
        this.splideInstance.Components.Autoplay.play();
        if (this.ambientVideo) {
          this.ambientVideo.play();
        }
        break;
    }
  }

  handleResize() {
    const sampleTextElem = this.slides[0].querySelector(".h2");
    const lineHeight = sampleTextElem.offsetHeight;
    setCssVar(this.elem, "--line-height", `${lineHeight}px`);
  }

  init() {
    // Check reduced motion preference before setting up
    this.checkReducedMotionPreference();
    
    window.addEventListener("load", this.handleResize.bind(this));
    window.addEventListener("resize", this.handleResize.bind(this));

    this.setupSplide();

    this.pauseButtons.forEach(button => {
      button.addEventListener("click", this.handlePauseButton.bind(this));
    });

  }
};
